import React from 'react';
import { UloadNotesProps } from '../interfaces';
import './UloadNotes.css';

const FILTER_DEFINITIONS: { [key: string]: string[] } = {
  'AMENA_BSR_P_DATA.MINP_BSR_INVEN_CTGY': ['COMP_CD', 'MTRL_ID', 'MTRL_CTGY'],
  'AMENA_BSR_P_DATA.MINP_BSR_INVEN_ESD_AVG_SLS': [
    'COMP_CD',
    'MTRL_TYP',
    'MTRL_ID',
    'MTRL_CTGY',
    'YR_MONTH_ID',
    'AVG_VALUE',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_INVEN_ESTMTD_DAY': [
    'COMP_CD',
    'MTRL_CTGY',
    'YR_MONTH_ID',
    'Prod_Brand_KG',
    'UNIT',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_INVEN_RSRV': [
    'COMP_CD',
    'MATERIAL_ID',
    'MTRL_CTGY',
    'YR_MONTH_ID',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_INVEN_SEED_AGNG': [
    'COMP_CD',
    'MTRL_ID',
    'MTRL_CTGY',
    'YR_MONTH_ID',
    'AMT_LCL_CRNCY',
    'BUCKET',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY': [
    'COMP_CD',
    'YR_MONTH_ID',
    'PLANT',
    'MTRL_ID',
    'FLAG',
    'THRSHLD_QTY',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_MULTILVL_MAPPING': [
    'COMP_CD',
    'ECC_GL_ACCOUNT',
    'GL_ACCOUNT_DESC',
    'HFM_MAPPING',
  ],
  'AMENA_BSR_P_DATA.MINP_HFM_FXD_CRNCY_RT': [
    'SCENRO_LBL_NM',
    'YR_ID',
    'PRD_VAL',
    'VW_LBL_NM',
    'ENTTY_LBL_NM',
    'VAL_LBL_NM2',
    'ACCT_LBL_NM',
    'ICP_LBL_NM',
    'CSTM_1_LBL_NM',
    'CSTM_2_LBL_NM',
    'CSTM_3_LBL_NM',
    'CSTM_4_LBL_NM',
    'TX_AMT_LOC_CURRENCY',
  ],
  'AMENA_BSR_P_DATA.MINP_HFM_FXD_CRNCY_RT_CSHFLW': [
    'SCENRO_LBL_NM',
    'YR_ID',
    'PRD_VAL',
    'VW_LBL_NM',
    'ENTTY_LBL_NM',
    'VAL_LBL_NM2',
    'ACCT_LBL_NM',
    'ICP_LBL_NM',
    'CSTM_1_LBL_NM',
    'CSTM_2_LBL_NM',
    'CSTM_3_LBL_NM',
    'CSTM_4_LBL_NM',
    'TX_AMT_LOC_CURRENCY',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_ACCT_SUB_GRP': [
    'ECC_GL_ACCOUNT',
    'ACC_SUB_GRP',
    'COMP_CD',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_DIM_CUSTOMER': [
    'COMP_CD',
    'SAP_AC',
    'CUST_NO',
    'CUST_NM',
    'CREDIT_LMT',
    'CREDIT_TERM',
    'PAYER_ID',
    'PAYER_NM',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_DIM_VENDOR': [
    'COMP_CD',
    'SAP_AC',
    'VENDOR_ID',
    'VNDR_NATURE',
    'PAYEMNT_TERM',
    'PAYEMNT_TRM_DESC',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_EXCLUSON_ACCT': ['ECC_GL_ACCOUNT', 'COMP_CD'],
  'AMENA_BSR_P_DATA.MINP_BSR_GCS_MAPPING': [
    'COMP_CD',
    'ACCOUNT_NO',
    'ACCOUNT_NM',
    'KC',
    'KC_DESC',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_GCS_QTR_DATA': [
    'COMP_CD',
    'QTR',
    'YR_NM',
    'KC',
    'KC_DESC',
    'FAILURE_TYP_CD',
    'FAILURE_TYP_DESC',
  ],
  'AMENA_BSR_P_DATA.MINP_BSR_GCS_SUMMRY': [
    'KEY_PASS',
    'KEY_VAL',
    'YR_QTR',
    'COMP_CODE',
    'KEY_TYP',
  ],
};

const UloadNotes: React.FC<UloadNotesProps> = (props: UloadNotesProps) => {
  const df = FILTER_DEFINITIONS[props.selectedFilter] || [];
  const midIndex = Math.ceil(df.length / 2); // Calculate middle index to split the array
  const leftColumn = df.slice(0, midIndex); // Left column items
  const rightColumn = df.slice(midIndex); // Right column items
  return (
    <div className='uload-notes-container'>
      <div className='uload-instructions'>
        <div>
          <b>Uload Notes:</b>
        </div>
        <div>
          <b>1.</b> Upload the correct file.
        </div>
        <div>
          <b>2.</b> Data should not be repeated.
        </div>
      </div>
      <div className='mandatory-columns-section'>
        <div>Below are the mandatory columns for Selected Uload:</div>
        <div className='columns-wrapper'>
          {df.length > 0 ? (
            <>
              <ul className='mandatory-columns-list'>
                {leftColumn.map((item, index) => (
                  <li key={`left-${index}`} className='list-item'>
                    {item}
                  </li>
                ))}
              </ul>
              <ul className='mandatory-columns-list'>
                {rightColumn.map((item, index) => (
                  <li key={`right-${index}`} className='list-item'>
                    {item}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className='no-columns'>
              No mandatory columns defined for the selected filter.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UloadNotes;
